module.exports = __webpack_public_path__ + "static/media/logo-ms.99fd5873.svg";